import React, { useState, useEffect } from 'react';
import { rolesMap, hasRole, redirectIfNotGranted, releaseSudo } from '../services/auth';
import Header from '../components/Header';
import Footer from '../components/Footer';
import DynamicMenu from '../components/DynamicMenu';
import Debug from '../components/Debug';
import '../css/GlobalLayout.css';

const fabStyle = (bottom) => ({
    position: 'fixed',
    bottom: `${bottom}px`,
    right: '24px',
    zIndex: 1000,
    padding: '10px 18px',
    fontSize: '13px',
    fontWeight: 500,
    background: 'var(--accent)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    boxShadow: 'var(--shadow-md)',
    transition: 'background-color 0.2s ease, transform 0.15s ease, box-shadow 0.2s ease',
});

const GlobalLayout = ({ children }) => {
    redirectIfNotGranted(rolesMap.AUTHENTICATED);

    const [showDebug, setShowDebug] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isSudoer, setIsSudoer] = useState(false);

    useEffect(() => {
        setIsAdmin(hasRole(rolesMap.admin));
        setIsSudoer(localStorage.getItem('sudoer_token') != null);
    }, []);

    useEffect(() => {

    }, []);

    const toggleDebug = () => {
        setShowDebug(prevState => !prevState);
    };

    const handleReleaseSudo = async () => {
        try {
            await releaseSudo();
            setIsSudoer(false);
        } catch (error) {
            console.error('Failed to release sudo:', error);
        }
    };

    return (
        <div className="container">
            <div className="Header">
                <Header />
            </div>
            <div className="Menu">
                <DynamicMenu />
            </div>
            <div className="Body">
                {children}
            </div>
            <div className="Footer">
                <Footer />
            </div>

            {isAdmin && (
                <button
                    onClick={toggleDebug}
                    style={fabStyle(60)}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.boxShadow = 'var(--shadow-lg)';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.boxShadow = 'var(--shadow-md)';
                    }}
                >
                    🛠 Debug
                </button>
            )}

            {isSudoer && (
                <button
                    onClick={handleReleaseSudo}
                    style={{
                        ...fabStyle(isAdmin ? 112 : 60),
                        background: '#ef4444',
                    }}
                    onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-2px)';
                        e.target.style.background = '#dc2626';
                    }}
                    onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.background = '#ef4444';
                    }}
                >
                    🔓 Release Sudo
                </button>
            )}

            {showDebug && (
                <div className="debug-overlay" onClick={toggleDebug}>
                    <div className="debug-content" onClick={(e) => e.stopPropagation()}>
                        <button onClick={toggleDebug} className="debug-close-button">
                            &times;
                        </button>
                        <Debug />
                    </div>
                </div>
            )}
        </div>
    );
};

export default GlobalLayout;
